// removed by extract-text-webpack-plugin
module.exports = {"root":"video-player__root","expiredSlate":"video-player__expiredSlate","playerComponent":"video-player__playerComponent","asvp":"video-player__asvp video-player__playerComponent","cvp":"video-player__cvp video-player__playerComponent","loadingSpinner":"video-player__loadingSpinner"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/video-player/styles.less
// module id = 75
// module chunks = 0